// @core/api/endpoints/admin/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { ExportAuditLogs } from './export_audit_logs';
import { GetAdminSettings } from './get_admin_settings';
import { GetAdminStats } from './get_admin_stats';
import { GetAuditLog } from './get_audit_log';
import { ListAuditLogs } from './list_audit_logs';
import { ListAuditLogsByActor } from './list_audit_logs_by_actor';
import { ListAuditLogsByResource } from './list_audit_logs_by_resource';
import { UpdateAdminSettings } from './update_admin_settings';

// Re-export individual endpoints
export {
  ExportAuditLogs,
  GetAdminSettings,
  GetAdminStats,
  GetAuditLog,
  ListAuditLogs,
  ListAuditLogsByActor,
  ListAuditLogsByResource,
  UpdateAdminSettings,
};

// Namespace export for convenient usage
export const adminApi = {
  ExportAuditLogs,
  GetAdminSettings,
  GetAdminStats,
  GetAuditLog,
  ListAuditLogs,
  ListAuditLogsByActor,
  ListAuditLogsByResource,
  UpdateAdminSettings,
};
